import React, {Fragment} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faSyncAlt} from "@fortawesome/free-solid-svg-icons";
import { BarLoader } from "react-spinners";

export default function() {
  const {
    nearbyStores,
    formattedAddress,
    locationServicesEnabled,
    collapsed,
    loading
  } = this.state;
  return (
    <Fragment>
    <div className={locationServicesEnabled ? 'form' : 'form block'}>
      <div className="store_address_wrap">
        {loading ? (
          <div className="button-loader">
            <BarLoader width={200} height={4} color={"white"} />
          </div>
        ) : (
          
          locationServicesEnabled ? (
            <Fragment>
              <button className="store_address" onClick={() => this.setState({ collapsed: !this.state.collapsed })}>
                <Fragment>Stores near {formattedAddress}</Fragment>
              </button>
              <button className="btn_retry" onClick={() => window.location.reload() }><FontAwesomeIcon icon={faSyncAlt} size="1x" /></button>
            </Fragment>
          ) : (
            <button className="store_address" onClick={() => window.location.reload() }>
              <Fragment>Try Again</Fragment>
            </button>
          )
        )}
      </div>
      
      {/* offline */}
      {!navigator.onLine && (
        <div className="connectivity">No internet connection found. App is running in offline mode.</div>
      )}
      {/* locationServicesEnabled */}
      {locationServicesEnabled ? (
        collapsed ? null : nearbyStores.length > 0 ? (
          nearbyStores.map((store, index) => this._renderStore(store, index))
        ) : (
          <div className="list-item">No nearby stores</div>
        )
      ) : !loading && (
        <div className="connectivity">Location services are not enabled.</div>
      )}
    </div>
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/screens/stores/nearby-stores/view.js